module.exports = __webpack_public_path__ + "img/icon1.5af15a6f.png";